// extracted by mini-css-extract-plugin
module.exports = {"chat-layout":"chat-layout_chat-layout__249-3","chat-layout__messages":"chat-layout_chat-layout__messages__1xjQj","chat-layout__input":"chat-layout_chat-layout__input__2GiTo"};